import { render, staticRenderFns } from "./PriceListList.vue?vue&type=template&id=e1d513fa"
import script from "./PriceListList.vue?vue&type=script&lang=js"
export * from "./PriceListList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports